import * as authActions from "@rentiohq/shared-frontend/dist/redux/auth/auth.actions";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { parsePhoneNumber } from "@rentiohq/web-shared/dist/utils/phone";
import {
  Box,
  Form,
  MainCard,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { enqueueSnackbar } from "@rentiohq/web-shared-next/dist/utils/snackbar";
import { useDispatch } from "react-redux";
import { profilePersonalSchema } from "./profilePersonalForm/schema.profilePersonal.list";

export const ProfilePersonal = () => {
  const dispatch = useDispatch();

  const { user } = authHooks.useSelf();

  if (!user) {
    return null;
  }

  const handleSubmit = async (values: any) => {
    const {
      firstname,
      lastname,
      email,
      phone,
      locale,
      street,
      number,
      box,
      zip,
      city,
      state,
      country,
    } = values;
    const { id, personalContactId } = user;

    const emailKey = email !== user?.email ? "unverifiedEmail" : "email";
    const phoneKey = phone !== user?.phone ? "unverifiedPhone" : "phone";

    let userInput = {
      id,
      firstname,
      lastname,
      [emailKey]: email,
      [phoneKey]: parsePhoneNumber(phone),
      locale,
    };

    const contactInput = {
      id: personalContactId,
      street,
      number,
      box,
      zip,
      city,
      state,
      country,
      countryId: country,
    };

    dispatch(
      authActions.updateUser.actions.start({
        user: userInput,
        contact: contactInput,
        onSuccess: () => {
          enqueueSnackbar({
            variant: "success",
            message: getLocalizedText("tenant.profile.edit.success"),
          });
        },
      }),
    );
  };

  return (
    <MainCard>
      <Box sx={{ maxWidth: "600px" }}>
        <Form
          onSubmit={handleSubmit}
          getSchema={profilePersonalSchema({ user })}
        />
      </Box>
    </MainCard>
  );
};
